import React from 'react';
import Helmet from 'react-helmet';
import Breadcrumb from '../common/Breadcrumb';
import BreadcrumbItem from '../common/BreadcrumbItem';
import Header from '../common/Header';
import { Link } from 'react-router';
import Tooltip from '../common/Tooltip';
import Option from './common/SafeSelectorOption';

class Index extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedCategory: '',
			btnDisabled: true
		};
	}

	componentDidMount() {
		global.sessionStorage.removeItem('selectedSize');
		global.sessionStorage.removeItem('selectedLockType');
		global.sessionStorage.removeItem('selectedProtection');
	}

	handleChange(e) {
		this.setState({
			selectedCategory: e.target.value,
			btnDisabled: false
		});
	}

	handleSubmit(e) {
		const { btnDisabled } = this.state;
		if (btnDisabled) {
			e.preventDefault();
		} else {
			global.dataLayer.push({
				event: 'Product Selector',
				eventCategory: 'Product Selector',
				eventAction: 'Continue - Step 1',
				eventLabel: global.location.pathname
			});
		}
	}

	render() {
		const { selectedCategory, btnDisabled } = this.state;
		const options = [
			{
				name: 'Fireproof Safes',
				value: '/products/fire-safes'
			},
			{
				name: 'Pistol Safes',
				value: '/products/pistol-safes'
			},
			{
				name: 'Cash Boxes',
				value: '/products/cash-boxes'
			},
			{
				name: 'Portable Safes',
				value: '/products/portable-safes'
			}
		];
		const types = options.map((item, index) => {
			return (
				<Option
					className="mb-2"
					key={index}
					id={`safeType${index + 1}`}
					name="safeType"
					value={item.value}
					checked={selectedCategory === item.value}
					onChange={e => this.handleChange(e)}
					label={item.name}
					trackEventAction="Safe Type"
					trackEventLabel={item.name}
				/>
			);
		});

		return (
			<div className="safe-selector">
				<Helmet>
					<title>Safe Selector | SentrySafe</title>
					<meta
						name="description"
						content="Find the safe that's right for your storage needs with the SentrySafe Safe Selector. Learn More."
					/>
				</Helmet>

				<Breadcrumb>
					<BreadcrumbItem label="Safe Selector" />
				</Breadcrumb>

				<Header title="First, do you need a specific type of safe?" />

				<span className="arrow-down" />

				<section className="section section-select-safe-type pt-4 pb-5">
					<div className="section-content row text-center">
						<div className="col">
							<h2>Safe Type</h2>
							<div className="my-4">
								<Option
									id="safeTypeAll"
									name="safeType"
									value="/safe-selector/capacity"
									checked={selectedCategory === '/safe-selector/capacity'}
									onChange={e => this.handleChange(e)}
									label="I need an all-purpose safe"
									trackEventAction="Safe Type"
									trackEventLabel="All-purpose safe"
								/>
							</div>

							<p className="text-break-h uppercase text-gray">
								<span className="bg-white">or</span>
							</p>

							<div className="my-4">
								{types}
							</div>

							<div className="safe-selector-actions">
								{
									btnDisabled ?
										<Tooltip
											trigger={
												<Link
													className="btn btn-primary disabled"
													to="#"
													onClick={e => this.handleSubmit(e)}
												>
													Continue
												</Link>
											}
											content="Please select an option to continue."
										/>
										:
										<Link
											className="btn btn-primary"
											to={selectedCategory}
											onClick={e => this.handleSubmit(e)}
										>
											Continue
										</Link>
								}
							</div>
						</div>
					</div>
				</section>
			</div>
		);
	}
};

export default Index;


// WEBPACK FOOTER //
// ./src/pages/safeSelector/Index.js